import React, { SVGProps } from 'react';

const SvgAdd = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			height='1em'
			viewBox='0 0 24 24'
			width='1em'
			fill='currentColor'
			className='svg-icon'
			{...props}>
			<path d='M0 0h24v24H0V0z' fill='none' />
			<path d='M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z' />
		</svg>
	);
}

export default SvgAdd;
